module.exports = __webpack_public_path__ + "static/img/QA.b9a250a6.png";